
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function AboutPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    // Schema.org JSON-LD for AboutPage
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "当院について - 南森町鍼灸院",
      "description": "南森町鍼灸院の院長紹介と経絡治療、美容鍼、小児鍼について詳しくご説明します。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
      "mainEntity": {
        "@type": "Person",
        "name": "田村 公子",
        "jobTitle": "鍼灸師・院長",
        "hasCredential": [
          {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "鍼師免許"
          },
          {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "灸師免許"
          }
        ],
        "alumniOf": {
          "@type": "EducationalOrganization",
          "name": "明治東洋医学院専門学校"
        },
        "memberOf": {
          "@type": "Organization",
          "name": "KACS（漢方鍼灸臨床研究会）"
        }
      }
    });
    document.head.appendChild(script);

    // Set page title and meta description
    document.title = "当院について - 南森町鍼灸院";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '南森町鍼灸院の院長紹介と経絡治療、美容鍼、小児鍼について詳しくご説明します。15年の臨床経験を持つ女性鍼灸師が丁寧に治療いたします。');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="shadow-sm border-b border-gray-100" style={{ backgroundColor: '#D8F25E' }}>
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center cursor-pointer">
              <div className="text-center">
                <h1 className="text-2xl md:text-4xl font-bold" style={{ fontFamily: '"Hiragino Sans", "Noto Sans JP", sans-serif', color: '#526D1A' }}>
                  南森町鍼灸院
                </h1>
                <p className="mt-1 md:mt-2 text-sm md:text-lg opacity-90" style={{ color: '#526D1A' }}>女性・小児専門（乳幼児〜小・中学生）</p>
              </div>
              <div className="ml-2 md:ml-0 -mt-2 md:-mt-4">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e2fcab9355782d68579ae8474689f655.webp"
                  alt="ハリネズミのマスコット"
                  className="w-16 h-16 md:w-28 md:h-28 object-contain"
                />
              </div>
            </Link>

            {/* デスクトップナビゲーション */}
            <nav className="hidden md:flex space-x-6 lg:space-x-8">
              <Link to="/" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                ホーム
              </Link>
              <Link to="/about" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer border-b-2 whitespace-nowrap" style={{ color: '#526D1A', borderColor: '#526D1A' }}>
                当院について
              </Link>
              <Link to="/menu" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer" style={{ color: '#526D1A' }}>
                治療料金
              </Link>
              <Link to="/access" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                アクセス
              </Link>
              <Link to="/contact" className="text-base lg:text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap" style={{ color: '#526D1A' }}>
                ご予約・お問い合わせ
              </Link>
            </nav>

            {/* モバイルメニューボタン */}
            <button
              className="md:hidden p-2 rounded-md cursor-pointer"
              style={{ color: '#526D1A' }}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* モバイルナビゲーション */}
          {isMobileMenuOpen && (
            <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col space-y-3">
                <Link 
                  to="/" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ホーム
                </Link>
                <Link 
                  to="/about" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2 border-b-2" 
                  style={{ color: '#526D1A', borderColor: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  当院について
                </Link>
                <Link 
                  to="/menu" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  治療料金
                </Link>
                <Link 
                  to="/access" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  アクセス
                </Link>
                <Link 
                  to="/contact" 
                  className="text-lg font-medium hover:opacity-80 transition-opacity cursor-pointer py-2" 
                  style={{ color: '#526D1A' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ご予約・お問い合わせ
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* ページタイトル */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#526D1A' }}>当院について</h1>
        </div>

        {/* ごあいさつ */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>ごあいさつ</h2>
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              鍼灸師として15年間、臨床にたずさわってまいりました。<br />
              日々めまぐるしい生活の中で、身体の痛みや疲れが常態化している方を多く診てきました。
            </p>

            <p>
              人は、一定の年齢をこえると、どうしても痛みや疲れが蓄積し、病気の状態にまで及んでしまうことがあります。<br />
              身体が疲れると皮膚やシワ、シミ、顔色など、体の表面にも影響が現れます。
            </p>

            <p>
              そうなる前に、鍼治療を受けてみられはいかがでしょうか。<br />
              不要な痛みや疲れを抱えて生活することは、決して「あたりまえ」ではありません。<br />
              また、鍼治療は体のメンテナンスにも最適な治療です。<br />
              全身に血液をめぐらせる力、痛みを取り除く力をもっています。<br />
              腰痛、肩こり、神経痛、神経症（うつ病など）、更年期障害など、元気を取り戻していかれる方をたくさん拝見し、改めて鍼治療の力を実感しています。
            </p>

            <p>
              当院では、脈を診て身体の病理状態を把握し、その状態に応じて経穴（ツボ）に鍼治療を行います。<br />
              本来備わっている自然治癒力を高め、身体を根本から改善させていくことを目指します。
            </p>

          </div>

          {/* 院長略歴 */}
          <div className="mt-12 bg-white rounded-lg shadow-lg p-8" style={{ backgroundColor: '#f8f9f0' }}>
            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: '#526D1A' }}>鍼灸師　院長　田村 公子</h3>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="md:col-span-2 space-y-4">
                <h4 className="text-xl font-semibold" style={{ color: '#526D1A' }}>略歴</h4>
                <div className="space-y-2 text-gray-700">
                  <p><strong>2010年</strong>　明治東洋医学院専門学校 鍼灸学科 卒業</p>
                  <p className="text-left">鍼師・灸師免許 取得</p>
                  <p className="text-left">鍼灸整骨院にて、経絡治療および美容鍼の臨床に15年間従事</p>
                  <p><strong>2025年8月</strong>　南森町鍼灸院 開院</p>
                </div>
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <p className="text-gray-700 mb-2">KACS（漢方鍼灸臨床研究会）会員</p>
                  <p className="text-gray-700">
                    <a
                      href="http://kacs.iinaa.net/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:opacity-80 transition-opacity cursor-pointer underline"
                      style={{ color: '#526D1A' }}
                    >
                      KACS（漢方鍼灸臨床研究会）のご案内
                    </a>
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/5cb7fd02ab9f609a2b6620a25b75d6df.webp"
                  alt="院内イラスト"
                  className="w-64 h-64 object-contain"
                />
              </div>
            </div>
          </div>
        </section>

        {/* 経絡治療とは */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>経絡治療とは</h2>
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 max-w-4xl text-left">
              経絡治療とは東洋医学の考え方に基づいた鍼灸治療です。
              人の体には「気・血」が流れる道筋（経絡）があり、この流れが滞ったり乱れると、痛みや不調が現れると考えます。
              経絡治療では、脈やお腹の状態などを診て、どの経絡に乱れがあるかを見極め、そこにやさしく鍼をして流れを整えていきます。
              症状のある部分だけでなく、全身のバランスを調整することで、自然治癒力を高め、不定愁訴から慢性的な症状まで幅広く対応できるのが特徴です。
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-plant-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>根本治療</h3>
                  <p className="text-gray-700">
                    木でたとえると「根っこ」に働きかける治療です。根が元気になれば木全体がいきいきとするように、体の土台を整えることで、さまざまな症状に対応できます。
                    肩こりや腰痛といった運動器の不調だけでなく、喘息や心臓の不調などの内科的な症状、蕁麻疹やアトピー性皮膚炎などの皮膚のトラブル、さらにはうつ病や更年期障害などの心やホルモンの不調まで、幅広くケアすることが可能です。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-search-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>早期発見・治療</h3>
                  <p className="text-gray-700">
                    病院の検査では異常が見つからなくても、脈を診ることで体の不調のサインを読み取ることができます。そのため、原因がはっきりしない不調でも、治療につなげていくことが可能です。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-shield-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>未病を治す</h3>
                  <p className="text-gray-700">
                    経絡治療は免疫力や自然治癒力を高めるので、症状がよくなった後も健康維持のために続けられます。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-heart-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>小児にやさしい</h3>
                  <p className="text-gray-700">
                    小児の場合は、鍉針（ていしん）や小児針といった刺さない針を使うため安心です。子どもたちもリラックスして喜んで受けてくれます。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 理念画像 */}
          <div className="bg-white rounded-lg shadow-lg p-8 mt-8" style={{ backgroundColor: '#f8f9f0' }}>
            <div className="text-center">
              <img
                src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/484bbe27e2f2acffee6d713394174903.webp"
                alt="当院の理念"
                className="w-full h-96 object-contain rounded-lg"
              />
              <div className="mt-6 text-left max-w-4xl mx-auto">
                <p className="text-lg text-gray-700 leading-relaxed">
                  木にたとえると、症状が出ている部分は「枝葉」が枯れている状態です。経絡治療では、その枝葉（症状）だけでなく、「幹や根（体の根本）」にも働きかけます。体の土台を整えることで全身の調子が良くなり、その結果として症状も自然に改善されていくと説明します。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 美容鍼セクション */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>美容鍼</h2>
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 max-w-4xl text-left">
              東洋医学では、顔には内臓の状態が現れるとされています。
              当院の美容鍼は、身体の内側から整える本治法と、顔に直接働きかける施術を組み合わせ、皮膚の新陳代謝を促進。血流を改善し、自然な美しさを引き出します。
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-heart-pulse-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>血流改善</h3>
                  <p className="text-gray-700">血行が良くなることで顔色が明るくなり、お肌にハリや潤いが生まれます。</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-time-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>エイジングケア</h3>
                  <p className="text-gray-700">シミ・シワ・くすみなど加齢や疲労による悩みにも効果が期待できます。</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-leaf-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>内面から美しく</h3>
                  <p className="text-gray-700">身体の内側から整うことで、お肌は健康的で若々しい印象に。免疫力も高まります。</p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-lg text-gray-700 font-medium">
              「健康」と「美しさ」を同時に叶える美容鍼を、ぜひご体験ください。
            </p>
          </div>
        </section>

        {/* 小児鍼セクション */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>小児鍼</h2>
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 max-w-4xl text-left">
              子ども用の刺さないはりです。刺さないはりを使って、皮膚をやさしく刺激します。
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-12">
            {/* 病気の治療 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-heart-pulse-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>病気の治療に</h3>
                  <div className="space-y-3">
                    <p className="text-gray-700">鼻炎・扁桃炎・咽頭炎・気管支喘息などの呼吸器疾患</p>
                    <p className="text-gray-700">食思不振・口内炎・便秘・下痢の消化器疾患</p>
                    <p className="text-gray-700">仮性近視・眼精疲労などの眼科疾患</p>
                    <p className="text-gray-700">夜尿症・てんかん・小児麻痺</p>
                    <p className="text-gray-700">肩こり・頭痛・チック・どもり・アトピー性皮膚炎</p>
                  </div>
                </div>
              </div>
            </div>

            {/* 健康管理 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-shield-heart-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div>
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>健康管理に</h3>
                  <p className="text-gray-700 mb-4">
                    小児鍼は、健康管理の一環として「かんむし」にとても効果的です。
                  </p>
                  <p className="text-gray-700 mb-4">
                    夜泣き・不機嫌・奇声・食欲不振・かみつくなどの症状に対して、高い効果が現れることが多く、多くのお子さまが穏やかに過ごせるようになります。
                  </p>
                  <p className="text-gray-700 font-medium">
                    小児鍼治療は、お母さんがリラックスできる場所でもあります。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 症状改善の流れ */}
          <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
            <div className="flex items-start mb-6">
              <i className="ri-refresh-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
              <div className="w-full">
                <h3 className="text-xl font-semibold mb-6" style={{ color: '#526D1A' }}>症状改善の流れ</h3>
                <div className="grid md:grid-cols-2 gap-8">
                  {/* 悪循環 */}
                  <div className="text-center">
                    <h4 className="text-lg font-semibold text-red-600 mb-4">子供のかんむし症状</h4>
                    <div className="space-y-4">
                      <div className="bg-red-50 p-4 rounded-lg">
                        <p className="text-gray-700">子供のかんむし症状</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-red-500"></i>
                      </div>
                      <div className="bg-red-50 p-4 rounded-lg">
                        <p className="text-gray-700">保護者のストレス増大</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-red-500"></i>
                      </div>
                      <div className="bg-red-50 p-4 rounded-lg">
                        <p className="text-gray-700">イライラを子供が察知</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-red-500"></i>
                      </div>
                      <div className="bg-red-50 p-4 rounded-lg">
                        <p className="text-gray-700">かんむし症状の慢性化</p>
                      </div>
                    </div>
                  </div>

                  {/* 好循環 */}
                  <div className="text-center">
                    <h4 className="text-lg font-semibold text-green-600 mb-4">かんむし症状改善すると</h4>
                    <div className="space-y-4">
                      <div className="bg-green-50 p-4 rounded-lg">
                        <p className="text-gray-700">かんむし症状改善</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-green-500"></i>
                      </div>
                      <div className="bg-green-50 p-4 rounded-lg">
                        <p className="text-gray-700">お母さんのストレス減少</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-green-500"></i>
                      </div>
                      <div className="bg-green-50 p-4 rounded-lg">
                        <p className="text-gray-700">平穏な精神状態を子供が察知</p>
                      </div>
                      <div className="flex justify-center">
                        <i className="ri-arrow-down-line text-2xl text-green-500"></i>
                      </div>
                      <div className="bg-green-50 p-4 rounded-lg">
                        <p className="text-gray-700">かんむし症状改善に相乗効果</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 適応疾患セクション */}
        <section className="mb-16">
          <div className="max-w-6xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4" style={{ color: '#526D1A' }}>適応疾患</h2>
              <p className="text-lg text-gray-600">当院の鍼灸治療で対応可能な疾患・症状</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {/* 神経系疾患 */}
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderLeftColor: '#526D1A' }}>
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-brain-line text-3xl" style={{ color: '#D8F25E' }}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3" style={{ color: '#526D1A' }}>神経系疾患</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li>• 神経痛</li>
                      <li>• 顔面神経麻痺</li>
                      <li>• 三叉神経痛</li>
                      <li>• 末梢神経障害</li>
                      <li>• 頭痛（片頭痛、緊張型頭痛など）</li>
                      <li>• 不眠症</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 运动器系疾患 */}
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-body-scan-line text-3xl" style={{ color: '#526D1A' }}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3" style={{ color: '#526D1A' }}>運動器系疾患</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li>• 頸椎症候群（むち打ちなどを含む）</li>
                      <li>• 肩関節周囲炎（五十肩）</li>
                      <li>• 腱鞘炎</li>
                      <li>• テニス肘（上腕骨外側上顆炎）</li>
                      <li>• 坐骨神経痛</li>
                      <li>• 腰痛症</li>
                      <li>• 変形性関節症</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 消化器系疾患 */}
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderLeftColor: '#526D1A' }}>
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 flex items-center justify-center mr-4 mt-1">
                    <img 
                      src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/41cb337d36453584ba250af69b342639.png" 
                      alt="消化器系疾患" 
                      className="w-10 h-10 object-contain"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3" style={{ color: '#526D1A' }}>消化器系疾患</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li>• 急・慢性胃炎</li>
                      <li>• 胃酸過多</li>
                      <li>• 胃下垂</li>
                      <li>• 胃痙攣</li>
                      <li>• 消化不良</li>
                      <li>• 下痢、便秘</li>
                      <li>• 過敏性腸症候群</li>
                      <li>• 胆石症（随伴症状）</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 婦人科疾患 */}
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-women-line text-3xl" style={{ color: '#526D1A' }}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3" style={{ color: '#526D1A' }}>婦人科疾患</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li>• 月経困難症</li>
                      <li>• 月経不順</li>
                      <li>• 不妊症の補助療法</li>
                      <li>• 更年期障害</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 耳鼻咽喉科・眼科疾患 */}
            <div className="mt-8 max-w-3xl mx-auto">
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderLeftColor: '#526D1A' }}>
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 flex items-center justify-center mr-4 mt-1">
                    <i className="ri-eye-line text-3xl" style={{ color: '#D8F25E' }}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-3" style={{ color: '#526D1A' }}>耳鼻咽喉科・眼科疾患</h3>
                    <div className="grid md:grid-cols-2 gap-4">
                      <ul className="space-y-2 text-gray-700">
                        <li>• 鼻炎（アレルギー性を含む）</li>
                        <li>• 副鼻腔炎</li>
                        <li>• 咽頭炎、扁桃炎</li>
                      </ul>
                      <ul className="space-y-2 text-gray-700">
                        <li>• 耳鳴り</li>
                        <li>• めまい（メニエール症候群など）</li>
                        <li>• 眼精疲労</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <p className="text-gray-600 bg-gray-50 p-4 rounded-lg max-w-4xl mx-auto text-left">
                ☆その他、お困りの症状については、お気軽にご相談ください。<br />
                <br />
                <strong>注記</strong><br />
                ・上記は「WHOが効果を認めた代表的の疾患リスト」です。<br />
                ・その後の研究では、これ以外の多くの症状に対しても鍼治療の有効性が示されています。<br />
                ・鍼治療は 症状の緩和・体質改善・全身調整 に寄与し、西洋医学と併用することでより高い効果が期待できます。
              </p>
            </div>
          </div>
        </section>

        {/* よくある質問セクション */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>よくある質問</h2>
          <div className="max-w-4xl mx-auto space-y-8">
            {/* Q1 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-question-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div className="w-full">
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>Q）鍼は痛くないですか？</h3>
                  <p className="text-gray-700 leading-relaxed">
                    A）当院で使用している鍼は、髪の毛ほどの細さですので、ほとんど痛みを感じることはありません。もちろん痛みの感じ方には個人差がありますので、その方の体調や症状に合わせて、鍼の太さや刺激の強さを調整いたします。初めての方でも安心して受けていただけるよう、丁寧に説明しながら施術を行います。
                  </p>
                </div>
              </div>
            </div>

            {/* Q2 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-question-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div className="w-full">
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>Q）鍼灸治療は合う・合わないがありますか？</h3>
                  <p className="text-gray-700 leading-relaxed">
                    A）鍼灸治療は体質や症状によって効果の現れ方に個人差があります。しかし、当院では経絡治療という方法で、お一人お一人の体質や症状に合わせた治療を行っておりますので、多くの方に効果を実感していただいています。初回の治療で体の反応を確認し、その方に最適な治療方針を立てていきます。
                  </p>
                </div>
              </div>
            </div>

            {/* Q3 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#526D1A' }}>
              <div className="flex items-start mb-4">
                <i className="ri-question-line text-3xl mr-4 mt-1" style={{ color: '#D8F25E' }}></i>
                <div className="w-full">
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>Q）どれくらいの期間で効果が現れますか？</h3>
                  <p className="text-gray-700 leading-relaxed">
                    A）症状や体質によって異なりますが、急性の症状（ぎっくり腰など）では1〜3回程度で改善することが多く、慢性的な症状では週1〜2回のペースで3〜6回程度で変化を感じられる方が多いです。体質改善や予防を目的とする場合は、月1〜2回の定期的な治療をおすすめしています。
                  </p>
                </div>
              </div>
            </div>

            {/* Q4 */}
            <div className="bg-white rounded-lg shadow-md p-6 border-l-4" style={{ borderLeftColor: '#D8F25E' }}>
              <div className="flex items-start mb-4">
                <i className="ri-question-line text-3xl mr-4 mt-1" style={{ color: '#526D1A' }}></i>
                <div className="w-full">
                  <h3 className="text-xl font-semibold mb-3" style={{ color: '#526D1A' }}>
                    Q）鍼治療に副作用はありますか？
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    A）鍼灸は薬のような副作用はほとんどありません。ただし、治療後に一時的にだるさや眠気を感じることがありますが、これは体が回復しようとする自然な反応です。また、まれに治療部位に軽い内出血が起こることがありますが、数日で自然に消失します。当院では使い捨ての鍼を使用しており、感染症の心配もありません。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 院内のご案内 */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12" style={{ color: '#526D1A' }}>院内のご案内</h2>
          <div className="space-y-12">
            {/* 受付・待合室 */}
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="grid grid-cols-2 gap-4">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/9645d231f21848205a7277454ba14f50.webp"
                  alt="受付・待合室"
                  className="w-full h-40 object-cover rounded-lg shadow-lg"
                />
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/1a52c2d5fda095a04217beeed7e9eca3.webp"
                  alt="受付・待合室"
                  className="w-full h-40 object-cover rounded-lg"
                />
              </div>
              <div>
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#526D1A' }}>受付・待合室</h3>
                <div className="text-gray-700 leading-relaxed">
                  <p>緑豊かな観葉植物と、明るく心地よい空間です。</p>
                </div>
              </div>
            </div>
            {/* 治療室 */}
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="order-2 md:order-1">
                <h3 className="text-2xl font-bold mb-4" style={{ color: '#526D1A' }}>治療室</h3>
                <div className="text-gray-700 leading-relaxed">
                  <p>清潔で落ちついた雰囲気の中で、安心して治療を受けていただけます。</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 order-1 md:order-2">
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/2d7e479aab0316d143e50b2504003142.webp"
                  alt="施術室"
                  className="w-full h-40 object-cover rounded-lg"
                />
                <img
                  src="https://static.readdy.ai/image/66b8c69278644cf9dd6637b765df0157/e8846de93aab368ba277fdba60e81d1b.webp"
                  alt="施術室"
                  className="w-full h-40 object-cover rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-gray-200 text-center text-gray-600">
          <div className="max-w-6xl mx-auto px-4">
            <p>© {new Date().getFullYear()} 南森町鍼灸院. All rights reserved.</p>
            <p className="mt-2">
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:opacity-80 transition-opacity cursor-pointer"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
